"use client";
import { createContext, ReactNode, useState } from "react";
import { getUserLocation, isSupported } from "../utils/user-location";

export interface GeoLocationType {
  result: {
    coords?: { lat: number; lon: number; accuracy?: number };
    timestamp?: number;
    error?: string;
  };
  isLoading: boolean;
  isSupported: boolean;
  watcher?: number;
}

export type GeoLocationContextType = [GeoLocationType, () => void];

const defaultLocation: GeoLocationType = {
  result: {
    coords: undefined,
    timestamp: undefined,
    error: undefined,
  },
  isLoading: false,
  isSupported: isSupported(),
  watcher: undefined,
};

export const GeoLocationContext = createContext<GeoLocationContextType>(
  // Necessary for type checking.
  // As per React docs, default not used when context is used with provider
  undefined as unknown as GeoLocationContextType,
);

export function GeoLocationProvider({ children }: { children: ReactNode }) {
  const [location, setLocation] = useState<GeoLocationType>(defaultLocation);

  const getLocation = () => {
    getUserLocation(location, setLocation);
  };

  return (
    <GeoLocationContext.Provider value={[location, getLocation]}>
      {children}
    </GeoLocationContext.Provider>
  );
}
